import parse from "html-react-parser";
import React, { ReactNode } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import buttonImage from "../../../assets/images/next.svg";
import paymentMethodCardActive from "../../../assets/images/payment-method-card-active.svg";
import paymentMethodCard from "../../../assets/images/payment-method-card.svg";
import paymentMethodMobileActive from "../../../assets/images/payment-method-mobile-active.svg";
import paymentMethodMobile from "../../../assets/images/payment-method-mobile.svg";
import optionActive from "../../../assets/images/selection-card-active.png";
import optionPassive from "../../../assets/images/selection-card-passive.png";
import AuthFooter from "../../../components/Auth/AuthFooter/AuthFooter";
import AuthHeaderBottom from "../../../components/Auth/AuthHeaderBottom/AuthHeaderBottom";
import AuthHeaderMobile from "../../../components/Auth/AuthHeaderMobile/AuthHeaderMobile";
import FbCard from "../../../components/Auth/FbCard/FbCard";
import PageTitle from "../../../components/Auth/PageTitle/PageTitle";
import ButtonPrimary from "../../../components/Buttons/ButtonPrimary/ButtonPrimary";
import { logout, setProfileWarningVisibility } from "../../../core/actions/app";
import { Constants } from "../../../core/helpers/constants";
import { history } from "../../../core/helpers/history";
import { router } from "../../../core/helpers/router";
import {
  getStorage,
  setStorage,
  storageRecaptcha,
  storageSubscriptionPeriod,
} from "../../../core/helpers/storage";
import { Utilities } from "../../../core/helpers/utilities";
import { IStore } from "../../../core/reducers";
import CardPaymentPage from "../CardPaymentPage/CardPaymentPage";
import { Privilages } from "./Privilages";
import "./SubscriptionPage.scss";

interface IProps {
  match: any;
  msisdn?: string;
  setProfileWarningVisibility: (isVisible: boolean) => void;
  logout: () => void;
}

interface IState {
  step: Step;
  subscriptionPeriod: SubscriptionPeriod;
  paymentMethod: PaymentMethod;
  recaptchaToken: string;
  isCaptchaError: boolean;
}

enum Step {
  period = "period",
  method = "method",
  card = "card",
}

export enum SubscriptionPeriod {
  monthly = "monthly",
  yearly = "yearly",
}

enum PaymentMethod {
  mobile = "mobile",
  vpos = "vpos",
}

class SubscriptionPage extends React.Component<IProps> {
  state: IState = {
    step: Step.period,
    subscriptionPeriod: SubscriptionPeriod.monthly,
    paymentMethod: PaymentMethod.vpos,
    recaptchaToken: "",
    isCaptchaError: false,
  };

  private readonly isMsisdnTurkish: boolean = false;

  constructor(props: IProps) {
    super(props);
    const msisdn = this.props.msisdn;
    if (!msisdn) {
      history.push(router.LOGIN_MSISDN);
    } else {
      this.isMsisdnTurkish = Utilities.isMsisdnTurkish(msisdn);
      if (!this.isMsisdnTurkish) {
        console.log("mint");
      }
    }
  }

  componentDidMount() {
    // Handles pop back from next page (removes subscriptionPeriod from url)
    if (this.props.match.params.subscriptionPeriod) {
      history.push(router.SUBSCRIPTION);
    }
    if (!this.isMsisdnTurkish) {
      this.setState({ subscriptionPeriod: SubscriptionPeriod.yearly });
    }
  }

  componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<{}>,
    snapshot?: any
  ) {
    if (prevProps.match !== this.props.match) {
      if (this.props.match.params.subscriptionPeriod) {
        this.setState({ step: Step.method });
      } else {
        this.setState({ step: Step.period });
      }
    }
  }

  private setSubscriptionPeriod(subscriptionPeriod: SubscriptionPeriod): void {
    this.setState({ subscriptionPeriod });
    // Store the subscription period in local storage
    setStorage(storageSubscriptionPeriod, subscriptionPeriod);
  }

  private setPaymentMethod(paymentMethod: PaymentMethod): void {
    this.setState({ paymentMethod });
  }

  private handleContinue(): void {
    if (Utilities.isNoPaymentTime()) {
      this.props.setProfileWarningVisibility(true);
      return;
    }
    const step = this.state.step;
    if (step === Step.period) {
      this.setState({ step: Step.method });
    } else if (step === Step.method) {
      this.setState({ step: Step.card });
    }

    // The code below is commented out as we're now handling the flow with step state
    /*
    if (step === Step.period) {
      if (this.isMsisdnTurkish) {
        if (this.state.subscriptionPeriod === SubscriptionPeriod.yearly) {
          this.redirectToPayByMe(this.state.subscriptionPeriod);
        } else {
          history.push(
            `${router.SUBSCRIPTION}/${this.state.subscriptionPeriod}`
          );
        }
      } else {
        this.redirectToPayByMe(SubscriptionPeriod.yearly);
      }
    } else if (step === Step.method) {
      if (this.state.paymentMethod === PaymentMethod.mobile) {
        history.push(router.MOBILE_PAYMENT);
      } else {
        // Redirect to the card payment page
        history.push("/payment");
      }
    }
    */
  }

  private redirectToPayByMe(period: SubscriptionPeriod) {
    const isRecaptcha = getStorage(storageRecaptcha);
    if (isRecaptcha) {
      if (!this.state.recaptchaToken) {
        this.setState({
          isCaptchaError: true,
        });
        return;
      }
      setStorage(storageRecaptcha, this.state.recaptchaToken);
    }
    Utilities.navigateToPayByMe(period);
  }

  private handleRecaptchaChange(token: string | null): void {
    if (token) {
      this.setState({
        isCaptchaError: false,
        recaptchaToken: token,
      });
    }
  }

  private renderOption(period: SubscriptionPeriod): ReactNode {
    const isSelected = this.state.subscriptionPeriod === period;
    const isYearly = period === SubscriptionPeriod.yearly;
    return (
      <div
        className={`option ${isYearly && "yearly"} ${isSelected && "selected"}`}
        onClick={() => this.setSubscriptionPeriod(period)}
      >
        <img
          className="selection-icon"
          src={isSelected ? optionActive : optionPassive}
          alt="tick"
        />
        {isYearly && <div className="discount">İNDİRİMLİ</div>}
        <div className="price-original">&nbsp;₺190&nbsp;</div>
        <div className="price">
          <span className="main">
            ₺
            {isYearly ? (
              <span>
                158<span className="float">,25</span>
              </span>
            ) : (
              190
            )}
          </span>
          &nbsp;/ay
        </div>
        <div className="note">*yıllık ödeme alınır.</div>
      </div>
    );
  }

  private renderOptionForeign(): ReactNode {
    return (
      <div className="option selected foreign">
        <img className="selection-icon" src={optionActive} alt="tick" />
        <div className="price">
          <span className="main">₺2.268</span>
          &nbsp;/yıl
        </div>
      </div>
    );
  }

  private renderOptionPaymentMethod(method: PaymentMethod): ReactNode {
    const isSelected = this.state.paymentMethod === method;
    let icon = "";
    let content = "";
    switch (method) {
      case PaymentMethod.mobile:
        icon = isSelected ? paymentMethodMobileActive : paymentMethodMobile;
        content = "<span>Mobile<br/>Ödeme</span>";
        break;
      case PaymentMethod.vpos:
        icon = isSelected ? paymentMethodCardActive : paymentMethodCard;
        content = "<span>Kredi<br/>Kartı</span>";
        break;
    }
    return (
      <div
        className={`option ${isSelected && "selected"}`}
        onClick={() => this.setPaymentMethod(method)}
      >
        <img
          className="selection-icon"
          src={isSelected ? optionActive : optionPassive}
          alt="tick"
        />
        <img className="method-icon" src={icon} alt="tick" />
        <div className="method">{parse(content)}</div>
      </div>
    );
  }

  private renderOptions(): ReactNode {
    return (
      <div className="option-wrapper">
        <label className="option-title">Abonelik teklifini seç</label>
        {this.isMsisdnTurkish ? (
          <div className="d-flex justify-content-between">
            {this.renderOption(SubscriptionPeriod.monthly)}
            {this.renderOption(SubscriptionPeriod.yearly)}
          </div>
        ) : (
          <div className="d-flex justify-content-between">
            {this.renderOptionForeign()}
          </div>
        )}
        {this.state.subscriptionPeriod === SubscriptionPeriod.yearly &&
          this.renderRecaptcha()}
        {this.renderButton()}
      </div>
    );
  }

  private renderOptionsPaymentMethod(): ReactNode {
    return (
      <div className="option-wrapper">
        <label className="option-title">Ödeme yöntemini seç</label>
        <div className="d-flex justify-content-between">
          {this.renderOptionPaymentMethod(PaymentMethod.vpos)}
          {/* {this.renderOptionPaymentMethod(PaymentMethod.mobile)} */}
        </div>
        {this.state.paymentMethod === PaymentMethod.vpos &&
          this.renderRecaptcha()}
        {this.renderButton()}
      </div>
    );
  }

  private renderRecaptcha(): ReactNode {
    const isRecaptcha = getStorage(storageRecaptcha);
    if (isRecaptcha) {
      return (
        // @ts-ignore
        <ReCAPTCHA
          className={`recaptcha mt-3 ${
            this.state.isCaptchaError ? "error" : ""
          }`}
          sitekey={Constants.recaptchaSiteKey}
          onChange={(token) => this.handleRecaptchaChange(token)}
        />
      );
    }
  }

  private renderButton(): ReactNode {
    return (
      <ButtonPrimary
        class="button-yellow mb-3"
        text={
          <React.Fragment>
            <span className="button-text">DEVAM ET</span>
            <img className="button-icon" src={buttonImage} alt="continue" />
          </React.Fragment>
        }
        callback={() => this.handleContinue()}
      />
    );
  }

  // Handle back button navigation based on current step
  private handleBackNavigation = (): void => {
    const { step } = this.state;

    if (step === Step.card) {
      // From card step, go back to method selection
      this.setState({ step: Step.method });
    } else if (step === Step.method) {
      // From method step, go back to period selection
      this.setState({ step: Step.period });
    } else {
      // From period (first step), do default action (logout and go to landing)
      this.props.logout();
      history.push(router.LANDING);
    }
  };

  render() {
    return (
      <div id="subscription-page">
        <div className="container">
          <div className="page-content">
            <AuthHeaderBottom />
            <AuthHeaderMobile
              pageTitle="ABONE OL"
              onBackClick={this.handleBackNavigation}
            />

            <div className="d-flex flex-column d-lg-none my-auto">
              <div className="d-flex justify-content-center align-items-center">
                {this.state.step !== Step.card && (
                  <>
                    <div className="mobile-info">
                      <p className="title">Taraftar Kartlı ol!</p>
                      <p className="text">AYRICALIKLI OL!</p>
                    </div>
                  </>
                )}
                <FbCard />
              </div>
              {this.state.step !== Step.card && <Privilages />}
              {this.state.step === Step.method &&
                this.renderOptionsPaymentMethod()}
              {this.state.step === Step.period && this.renderOptions()}
              {this.state.step === Step.card && <CardPaymentPage />}
            </div>

            <div className="d-none d-lg-flex m-auto">
              <div className="col-left">
                <div className="desktop-box">
                  {this.state.step !== Step.card && (
                    <>
                      <PageTitle title="TARAFTAR KARTLI OL" />
                      <p className="subtitle">Ayrıcalıklı ol!</p>
                      <span className="note">
                        Fenerbahçeli'nin Taraftar Kart'ı var!
                        <br />
                        Şimdi abone ol, avantajları kaçırma!
                      </span>
                    </>
                  )}
                  {this.state.step === Step.method &&
                    this.renderOptionsPaymentMethod()}
                  {this.state.step === Step.period && this.renderOptions()}
                  {this.state.step === Step.card && <CardPaymentPage />}
                </div>
              </div>
              <div className="col-right">
                <FbCard isBG={true} />
                <Privilages />
              </div>
            </div>

            <AuthFooter />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      setProfileWarningVisibility,
      logout,
    },
    dispatch
  );
};
const mapStateToProps = (store: IStore) => {
  return {
    msisdn: store.loginMsisdn.msisdn,
  };
};
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionPage);
